import React, {PropTypes} from 'react';
import {resetSectionValueTo} from '../groups/utils';
import objectAssign from 'object-assign';
import FormInput from './forminput.react';

export default class DropdownInput extends FormInput {
  static propTypes = {
    updateAction: PropTypes.func.isRequired,
    children: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    otherField: PropTypes.string,
    otherFieldName: PropTypes.string,
    otherFieldMaxCharactfers: PropTypes.number,
    label: PropTypes.string
  }

  isOtherFieldEnabled(value) {
    const {otherField} = this.props;

    if (value !== null && value !== undefined && value !== '') {
      if ('string' === typeof otherField && otherField.length > 1) {
        return value[otherField] === true;
      }
    }

    return false;
  }

  onListChange(event) {
    const {updateAction, value, name, otherField, otherFieldName} = this.props;
    const {target: {value: selectedValue}} = event;
    const result = resetSectionValueTo(value, false);

    if (selectedValue === '') return;

    if (selectedValue === otherField) {
      result[selectedValue] = true;
      result[otherFieldName] = '';
    } else {
      result[selectedValue] = true;
      result[otherFieldName] = '';
    }

    updateAction({target: {name, value: result}});
  }

  onInputChange(event) {
    const {
      updateAction,
      value,
      name,
      otherFieldName
    } = this.props;
    const {target: {value: inputValue}} = event;
    let result = objectAssign({}, value);

    if ('string' === typeof otherFieldName && otherFieldName.length > 1) {
      result[otherFieldName] = inputValue;
    } else {
      throw new Error(
          `DropDown(${name}).onInputChange:error missing otherFieldName`);
    }

    updateAction({target: {name, value: result}});
  }

  render() {
    const {
      children,
      value,
      otherField,
      otherFieldName,
      name,
      otherFieldMaxCharacters,
      label
    } = this.props;

    // TODO: Thiso ne should be used instead.
    // if ('object' !== typeof value || value === null) {
    //   throw new Error('Dropdown.render: Invalid venueType value:' + value);
    // }

    let result = (
      <h5>Fetching list of venue types</h5>
    );

    if (typeof value === 'object' && value !== null) {
      const selectedValue = Object.keys(value)
        .filter((key) => value[key])[0];

      const isDisabled = !this.isOtherFieldEnabled(value);
      const otherDetails = value[otherFieldName];

      result = (
        <div className="form-dropdown form-group">
          {
            label &&
            <label>{label}</label>
          }
          <select
            className="form-control"
            id="venueTypes"
            name={name}
            onChange={::this.onListChange}
            value={selectedValue}>
            {children}
          </select>
          {otherField && !isDisabled &&
            <input
              className="form-control"
              disabled={isDisabled}
              onChange={::this.onInputChange}
              type="text"
              value={otherDetails}
              maxLength={otherFieldMaxCharacters}
              />
          }
        </div>
      );
    } else {
      throw new Error(`Dropdown.render:error invalid value: ${value}`);
    }

    return result;
  }
}
